import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import blogs from '../../../assets/json/blog-data.json'
import { Link } from 'react-router-dom';
const Blog = () => {  return (
    <div id="blog-section" className="max-w-7xl mx-auto px-4">
      {/* <div className="max-w-7xl mx-auto px-4 lg:pr-14 mt-20">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mx-auto border">
          <div className="w-full md:w-1/2 overflow-hidden">
            <img
              src="/assets/image/recap_cart.png"
              alt="Industrial Facility"
              className="w-full h-auto object-cover transition-transform duration-300 transform scale-110 hover:scale-100"
            />
          </div>
          <div className="w-full md:w-1/2 flex flex-col justify-between h-full mt-4 md:mt-10">
            <div>
              <p className="text-black text-[24px] sm:text-[20px] md:text-[20px] px-4  lg:text-[30px] leading-relaxed font-bold">
                A Recap of the 2025 Ohio Craft Brewars Conference
              </p>
            </div>
            <div className="mt-10 sm:mt-10 lg:mt-32 px-4">
              <p className="text-[#979797] text-sm md:text-lg leading-relaxed">
                6 mins
              </p>
              <p className="text-black text-sm md:text-lg leading-relaxed">
                Automation, Industrial Hose, Events
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {blogs.map((blog) => (
              <Card key={blog.id} sx={{ maxWidth: 345 }}>
            <CardActionArea>
            <Link to={`/about/blog/fluid-connector/${blog.id}`}>
                            <CardMedia
                component="img"
                height="140"
                image={blog.imagePath}
                alt={blog.title}
                className="transition-transform duration-300 transform scale-110 hover:scale-100"
              />
            
              <CardContent className="flex flex-col justify-between text-left p-4 gap-4 md:gap-6 lg:gap-8 min-h-[220px] md:min-h-[250px] lg:min-h-[250px]">

                <div className="flex-1 flex items-start mt-6">
                  <p className="text-black text-[18px] md:text-[19px] lg:text-[20px] font-medium font-helvetica leading-tight">
                  {blog.title}
                  </p>
                </div>
                <div className="flex flex-col mb-2">
                  <p className="text-[#979797] text-md">{blog.read}</p>
                  <p className="text-black text-base font-medium font-helvetica">{blog.category}</p>
                </div>
             
              </CardContent>
              </Link>
            </CardActionArea>
          </Card>
          ))}
     

        </div>
      </div>
    </div>

  );
}

export default Blog;
